const PUSH_NOTIFICATION_STATUSES = {
  SCHEDULED: 'scheduled',
  QUEUED: 'queued',
  FAILED: 'failed',
};

export default PUSH_NOTIFICATION_STATUSES;
